<template>
  <div class="salepage">
    <router-view></router-view>
  </div>

</template>

<script>

export default {
  name: 'SalePage',
  components: {
  },
  data: function () {
    return {
    }
  },
  mounted: function () {
    this.$store.commit('displaySettings/setShowMenu', true)
    this.$store.commit('displaySettings/showNavbarOverride', true)
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.salepage {
}

</style>
